module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2B6XR"))).then(() => parcelRequire('hEqeo'));